<template>
    <div class="content">
        <div class="education_list">
            <div class="education_content" v-for="(v,i) in projectArr" :key="i" @click="editInfo(v)">
                <div class="education_content_top">
                    <span class="college">{{v.project_name}}</span>
                    <span class="timer">{{v.start_date}}-{{v.end_date}}</span>
                </div>
                <div class="education_content_bottom">
                    <span>担任角色：{{v.role_name}}</span>
                    <img class="del" :src="require('@/assets/img/del.png')" alt="" @click.stop="deletion(v)">
                </div>
                <div class="work_result" v-if="v.work_result">
                    工作成果:{{v.work_result}}
                </div>
                <div class="imglist">
                    <div class="img_item">
                        <img v-for="(v,i) in JSON.parse(v.show_images)" :key="i" :src="v"/>
                    </div>  
                </div>
            </div>
        </div>
        <van-button plain type="danger" @click="add">添加</van-button>
        <van-button type="danger" class="go" @click="next">提交简历</van-button>
        <load :loading="loading"></load>
    </div>
</template>

<script>
import { getProjectListApi,editProjectApi } from '@/api/interview'
import Load from "@/components/Loading"
    export default {
        data(){
            return {
                projectArr:[],
                show:true,
                id:sessionStorage.getItem("ID") || 0,
                loading:false,
            }
        },
        methods:{
            // 删除
            deletion(item){
                this.loading = true
                const params = {
                    resume_id:sessionStorage.getItem("ID"),
                    ...item,
                    status: 0
                }
                editProjectApi(params).then(res=>{
                    if(res.errNo===0){
                        this.getData()
                    }
                })
            },
            // 添加
            add(){
                this.$router.push({path:"/interviews/project"})
            },
            // 编辑条目
            editInfo(item){
              console.log(item,'item')
              var info = JSON.stringify(item)
              this.$router.push({path:"/interviews/project",query:{id: item.id}})
            },
            // 下一步
            next(){
                this.$router.push({path:"/interviews/resume"})
            },
            // 获取数据
            async getData(){
                const list = await getProjectListApi({resume_id:this.id})
                this.projectArr = list.result,
                this.loading = false
            }
        },
        created(){
            const id = sessionStorage.getItem('ID') || 0
            this.id = id
            if(id){
                this.loading = true
            }
            this.getData()
        },
        components: {
            Load
        }
    }
</script>

<style scoped lang="less">
.imglist {
    width: 100%;
    padding-top: 20px;  
    .img_item {
        width: 90%;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        column-count: 3;
        column-gap: 30px;
        img {
            width: 180px;
            height: 180px;
            margin-top: 20px;
        }
    }    
}
/deep/ .van-button {
    width: 88%;
    margin: 0 auto;
    border-radius: 10px;
}
.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .go {
        margin-top: 30px;
    }
}
.education_list {
    width: 90%;
    padding: 75px 37px 0 43px;
    font-size: 27px;
}
.education_content {
    padding-bottom: 54px;
    .education_content_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 27px;
        .college {
            font-weight: 900;
        }
        .timer {
            color: #a1a1a1;
            font-size: 19px;
        }
    }
    .education_content_bottom {
        display: flex;
        justify-content: space-between;
        .del{
            width: 34px;
            height: 34px;
        }
    }
    .work_result {
        padding-top: 30px;
    }
}
</style>